// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b9a935e","239":"25de9070","455":"dc6d044a","488":"0760efba"}[chunkId] + ".chunk.js";
};